import React from "react";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";

function ErrorPage({ error }) {
  return (
    <div
      style={{
        display: "flex",
        height: "90vh",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        lineHeight: "1.5",
        textAlign: "center",
      }}
    >
      {error && error!==null && error.status == 404 ? (
        <div>
          <SentimentVeryDissatisfiedIcon
            color="#262080"
            style={{ fontSize: "200px", color: "#262080" }}
          />
          <p style={{ fontSize: "100px", color: "#262080", fontWeight: "600" }}>
            404
          </p>
          <p
            style={{
              fontSize: "48px",
              color: "#8985B8",
              fontWeight: "500",
              marginTop: "-40px",
            }}
          >
            Page not found
          </p>
          <p style={{ fontSize: "24px", color: "#33333366" }}>
            We're sorry the page you requested could not be found.
          </p>
        </div>
      ) : (error && error!==null && error.status == 500) ? (
        <div>
          <SentimentVeryDissatisfiedIcon
            color="#262080"
            style={{ fontSize: "200px", color: "#262080" }}
          />
          <p style={{ fontSize: "100px", color: "#262080", fontWeight: "600" }}>
            500
          </p>
          <p
            style={{
              fontSize: "48px",
              color: "#8985B8",
              fontWeight: "500",
              marginTop: "-40px",
            }}
          >
            Server Error
          </p>
        </div>
      ) : (
        <div>
          <SentimentVeryDissatisfiedIcon
            color="#262080"
            style={{ fontSize: "200px", color: "#262080" }}
          />
          <p
            style={{
              fontSize: "40px",
              color: "#8985B8",
              fontWeight: "500"              
            }}
          >
            Something went wrong. Please try again later
          </p>
        </div>
      )}
    </div>
  );
}

export default ErrorPage;
